import { BrandedNavBar } from "@nulogy/components";
import SiteSwitcherContainer from "components/common/SiteSwitcherContainer";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import compact from "lodash/compact";
import Authorization from "policies/Authorization";
import React from "react";
import styled from "styled-components";
import { authenticationMenu, linksMenu, settingsMenu } from "./applicationNavBarMenus";
import syncMenu from "./syncMenu";

const AppNavBar = styled(BrandedNavBar)`
  div[class*="MenuText"] {
    // for SiteSwitcher
    padding: 0 16px;
  }
`;

// HACK: These styles are copied from NDS and should be replaced when they export/provide these styles for use
const NavBarButton = styled.button(({ theme }) => ({
  "&:disabled": {
    opacity: ".5",
  },
  "&:focus": {
    boxShadow: theme.shadows.focus,
  },
  "&:hover, &:focus": {
    backgroundColor: theme.colors.whiteGrey,
    color: theme.colors.blackBlue,
    cursor: "pointer",
    outline: "none",
  },
  backgroundColor: "transparent",
  border: "none",
  borderRadius: theme.radii.medium,
  color: theme.colors.darkBlue,
  display: "block",
  fontSize: `${theme.fontSizes.medium}`,
  fontWeight: `${theme.fontWeights.medium}`,
  lineHeight: theme.lineHeights.base,
  padding: `${theme.space.x1} ${theme.space.x2}`,
  textDecoration: "none",
  transition: ".2s",
  verticalAlign: "middle",
}));

function ApplicationNavBar({ environment }) {
  const applicationContext = useApplicationContext();
  const policy = Authorization.usePolicy();

  const menuData = {
    primaryMenu: linksMenu({ policy }),
  };

  menuData.secondaryMenu = compact([
    {
      name: <SiteSwitcherContainer />,
    },
    helpMenu(),
    pendoMenu(),
    syncMenu({ applicationContext, policy }),
    settingsMenu({ applicationContext, policy }),
    authenticationMenu({ applicationContext }),
  ]);

  return (
    <AppNavBar
      brandingLinkHref={brandingLinkHref({ applicationContext })}
      className="spec-nav-bar"
      environment={environment || null}
      menuData={menuData}
    />
  );
}

export default React.memo(ApplicationNavBar, () => true);

function brandingLinkHref({ applicationContext }) {
  if (applicationContext.site.externalId) {
    return applicationContext.packmanagerUrl;
  }

  return "#";
}

function helpMenu() {
  return {
    name: "HelpDesk",
    render: () => (
      <NavBarButton
        onClick={() => {
          zE("webWidget", "show");
          document.getElementById("launcher").contentWindow.document.querySelector("button").click();
        }}
      >
        HelpDesk
      </NavBarButton>
    ),
  };
}

function pendoMenu() {
  return {
    name: "Guided tours",
    render: () => <NavBarButton id="guided-tours">Guided tours</NavBarButton>,
  };
}
